import { GroupChatMember } from "@/server/types/member";
import { create } from "zustand";
import { generateChatSecretKey } from "@/lib/crypto/crypto";
import { generateUuid7 } from "@/utils/uuid7";

type State = {
  step: number;
  newChatId: string;
  newCSK: string;
  ownerSecurePayload: string;
  usernames: string[];
  members: GroupChatMember[];
};

type Actions = {
  setStep: (step: number) => void;
  initNewChat: () => void;
  setOwnerSecurePayload: (payload: string) => void;
  addChatMember: (member: GroupChatMember) => void;
  removeChatMember: (username: string) => void;
  addUsername: (username: string) => void;
  removeUsername: (username: string) => void;
  resetNewGroupChatState: () => void;
};

const initialState: State = {
  step: 1,
  newChatId: "",
  newCSK: "",
  ownerSecurePayload: "",
  usernames: [],
  members: [],
};

export const useNewGroupChatState = create<State & Actions>()((set) => ({
  // State
  ...initialState,

  // Actions
  setStep: (step: number) => {
    set({
      step,
    });
  },
  initNewChat: () => {
    // TO DO - Check if the newChatId and newCSK are better generated here or in 'prepareGroupChatOwner'
    set({
      newChatId: generateUuid7(),
      newCSK: generateChatSecretKey(),
    });
  },
  setOwnerSecurePayload: (payload: string) => {
    set({
      ownerSecurePayload: payload,
    });
  },
  addChatMember: (member: GroupChatMember) => {
    set((state) => ({
      members: [...state.members, member],
    }));
  },
  removeChatMember: (username: string) => {
    set((state) => ({
      members: state.members.filter((member) => member.username !== username),
    }));
  },
  addUsername: (username: string) => {
    set((state) => ({
      usernames: [...state.usernames, username],
    }));
  },
  removeUsername: (username: string) => {
    set((state) => ({
      usernames: state.usernames.filter((name) => name !== username),
    }));
  },
  // RESET
  resetNewGroupChatState: () => {
    set(initialState);
  },
}));
